export const escapeHtml = (value = "") => String(value)
  .replaceAll("&", "&amp;")
  .replaceAll("<", "&lt;")
  .replaceAll(">", "&gt;")
  .replaceAll('"', "&quot;")
  .replaceAll("'", "&#039;");

export function safeUrl(value, fallback = "/legacy/images/ball.png") {
  try {
    const raw = String(value || "");
    const url = new URL(raw, window.location.origin);
    if (import.meta.env.DEV && /^https?:\/\//i.test(raw)) {
      if (url.hostname === "app.fipavonline.it") return `${window.location.origin}/_api${url.pathname}${url.search}`;
      if (["fipavonline.it", "www.fipavonline.it", "localhost", "127.0.0.1"].includes(url.hostname)) {
        if (url.pathname.startsWith("/img/loghi/")) {
          return `${window.location.origin}/local-loghi/${url.pathname.slice("/img/loghi/".length)}${url.search}`;
        }
        return `${window.location.origin}/_legacy${url.pathname}${url.search}`;
      }
    }
    if (url.protocol === "http:" || url.protocol === "https:") {
      if (window.location.protocol === "https:" && url.protocol === "http:") url.protocol = "https:";
      return url.href;
    }
  } catch (_) {
    // Il fallback viene usato per URL non validi.
  }
  return fallback;
}

export const validCommitteeId = (value) => /^[A-Za-z0-9_-]+$/.test(value || "");
export const validNumericId = (value) => /^\d+$/.test(value || "");

export function nonRedundantSubtitle(title, subtitle) {
  const value = String(subtitle || "").trim();
  if (!value) return "";
  const normalize = (text) => String(text || "")
    .toLocaleLowerCase("it")
    .replace(/[\s\u00a0]+/g, " ")
    .trim();
  return normalize(title).includes(normalize(value)) ? "" : value;
}

export function selectedCommittee() {
  const queryValue = new URLSearchParams(window.location.search).get("comi");
  if (validCommitteeId(queryValue)) {
    sessionStorage.setItem("comitato", queryValue);
    return queryValue;
  }
  const saved = sessionStorage.getItem("comitato");
  return validCommitteeId(saved) ? saved : "";
}

export function setSelectedCommittee(id) {
  if (validCommitteeId(id)) sessionStorage.setItem("comitato", id);
}

export function committeeFromStandings(payload) {
  const standings = Array.isArray(payload) ? payload[0]?.data : payload?.data;
  const committee = String(standings?.["commettee-id"] || "");
  return validCommitteeId(committee) ? committee : "";
}

export function points(match) {
  const a = Array.isArray(match.pt_a) ? match.pt_a : [];
  const b = Array.isArray(match.pt_b) ? match.pt_b : [];
  const sets = a.map((score, index) => `${escapeHtml(score)}/${escapeHtml(b[index] ?? "")}`).join(" · ");
  const extra = match.sp_a !== undefined && String(match.sp_a) !== ""
    ? ` #${escapeHtml(match.sp_a)}/${escapeHtml(match.sp_b)}`
    : "";
  return `${sets}${extra}`;
}

export function formatMatchDate(value) {
  const text = String(value || "");
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(text.trim());
  if (!match) return text;
  const [, day, month, year] = match;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() !== Number(month) - 1 || date.getUTCDate() !== Number(day)) return text;
  const weekdays = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
  return `${weekdays[date.getUTCDay()]} ${text.trim()}`;
}

export function formatDateLabel(date) {
  return new Intl.DateTimeFormat("it-IT", { weekday: "short", day: "numeric", month: "short" }).format(date);
}

export function errorMessage(error) {
  if (error?.name === "AbortError") return "Richiesta scaduta. Riprova tra poco.";
  if (error instanceof TypeError) {
    return "Il servizio dati non è raggiungibile dal browser. Verificare CORS per public.fipavonline.it.";
  }
  return error?.message || "Si è verificato un errore durante il caricamento.";
}
